import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import {List } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Row, Col } from "react-bootstrap";
import CsvDownloadButton from 'react-json-to-csv'
import { useNavigate, Link, useParams , useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';

const CustomTable = ({ globalSearch=false }) => {
  const navigate = useNavigate();    
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [apiData, setApiData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    refnum: 'contains',
    prefnum : 'contains',
    trandate: 'contains',
    requesttype: 'contains',
    status: 'contains'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
          filterQuery+=`&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    // Get return request list
    // /account/salesreturn
    let url = `/account/salesreturn?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.salesreturn.items??[]);
          setRowCount(response.data?.data.salesreturn.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };


  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.refnum,
        id: 'refnum',
        header: 'Request',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'prefnum',
        header:  "Order",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'trandate',
        header:  "Requested Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()?cell.getValue().split('T')[0]:""}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
        Filter: ({ column, header, table }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: contains</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'requesttype',
        header:  "Type",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'status',
        header:  "Status",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: false,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }
      //end
    ],
    [],
  );

  return (
    <>
      <div className="toolbar">
          <div className="row">
              <div className="col-sm-3 text-right" style={{ float: "right" }}>
                  <a href="#" onClick={() => navigate(`/template-details`)}>+ Add New</a>
              </div>
          </div>
      </div>
        <MaterialReactTable
          columns={columns}
          data={data}
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{
            showColumnFilters: false
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef}
          rowCount={rowCount}
          enableEditing
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Details">
                <IconButton onClick={() => navigate(`/return-details?refnum=${row.original.prefnum}&status=return`)}>
                  <List />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
    </>
  );
};

export default CustomTable;
